<template>
  <s-wrapper
    :variant="buttonVariant"
    :size="buttonSize"
    :block="block"
    :outline="outline"
    :pill="pill"
  >
    <slot />
  </s-wrapper>
</template>

<script>
  import { AppButtonProps, SWrapper } from './styles'

  export default {
    name: 'AppButton',
    components: {
      SWrapper,
    },
    props: AppButtonProps,
    computed: {
      buttonVariant() {
        const variants = ['primary', 'light'];
        const variant = variants.includes(this.variant) ? this.variant : 'primary';
        return variant;
      },
      buttonSize() {
        const sizes = ['sm', 'md', 'lg'];
        const size = sizes.includes(this.size) ? this.size : 'md';
        return size;
      }
    }
  }
</script>